export enum QuestionnaireContextTypes {
  PRIMARY    = 'primary',
  GP_EDITING = 'gp_editing',
}

export const SEARCH_THRESHOLD = 30;
